import {
  getObjects,
  getObject,
  addObject,
  updateObject,
  deleteObject,
  getObjectsWithParams,
} from "./Api";

// ICU Admissions
export const listICUAdmissions = async (params = {}, token = "") => {
  return await getObjectsWithParams("icu-admissions", params, token);
};

export const getICUAdmission = async (id, token = "") => {
  return await getObject("icu-admissions", id, token);
};

export const createICUAdmission = async (data, token = "") => {
  return await addObject("icu-admissions", data, token);
};

export const updateICUAdmission = async (id, data, token = "") => {
  return await updateObject("icu-admissions", data, id, token);
};

export const deleteICUAdmission = async (id, token = "") => {
  return await deleteObject("icu-admissions", id, token);
};

export const getAvailableICUBeds = async (params = {}, token = "") => {
  return await getObjectsWithParams("icu-admissions/available-beds", params, token);
};

export const getICUDashboard = async (token = "") => {
  return await getObjects("icu-admissions/dashboard", token);
};

export const dischargeICUPatient = async (id, data, token = "") => {
  return await addObject(`icu-admissions/${id}/discharge`, data, token);
};

export const transferICUPatient = async (id, data, token = "") => {
  return await addObject(`icu-admissions/${id}/transfer`, data, token);
};

export const assignICUNurse = async (admissionId, data, token = "") => {
  return await addObject(`icu-admissions/${admissionId}/assign-nurse`, data, token);
};

export const getICUNurses = async (admissionId, token = "") => {
  return await getObjects(`icu-admissions/${admissionId}/nurses`, token);
};

export const getICUActivityLogs = async (admissionId, token = "") => {
  return await getObjects(`icu-admissions/${admissionId}/activity-logs`, token);
};

// ICU Rounds
export const listICURounds = async (params = {}, token = "") => {
  return await getObjectsWithParams("icu-rounds", params, token);
};

export const getICURound = async (id, token = "") => {
  return await getObject("icu-rounds", id, token);
};

export const createICURound = async (data, token = "") => {
  return await addObject("icu-rounds", data, token);
};

export const updateICURound = async (id, data, token = "") => {
  return await updateObject("icu-rounds", data, id, token);
};

export const deleteICURound = async (id, token = "") => {
  return await deleteObject("icu-rounds", id, token);
};

export const getICURoundsDashboard = async (token = "") => {
  return await getObjects("icu-rounds/dashboard", token);
};

// ICU Nurse Assignments
export const listICUNurseAssignments = async (params = {}, token = "") => {
  return await getObjectsWithParams("icu-nurse-assignments", params, token);
};

export const getICUNurseAssignment = async (id, token = "") => {
  return await getObject("icu-nurse-assignments", id, token);
};

export const createICUNurseAssignment = async (data, token = "") => {
  return await addObject("icu-nurse-assignments", data, token);
};

export const updateICUNurseAssignment = async (id, data, token = "") => {
  return await updateObject("icu-nurse-assignments", data, id, token);
};

export const deleteICUNurseAssignment = async (id, token = "") => {
  return await deleteObject("icu-nurse-assignments", id, token);
};

// ICU Activity Logs
export const listICUActivityLogs = async (params = {}, token = "") => {
  return await getObjectsWithParams("icu-activity-logs", params, token);
};

export const getICUActivityLog = async (id, token = "") => {
  return await getObject("icu-activity-logs", id, token);
};

export const createICUActivityLog = async (data, token = "") => {
  return await addObject("icu-activity-logs", data, token);
};

// ICU Charges
export const listICUCharges = async (params = {}, token = "") => {
  return await getObjectsWithParams("icu-charges", params, token);
};

export const getICUCharge = async (id, token = "") => {
  return await getObject("icu-charges", id, token);
};

export const createICUCharge = async (data, token = "") => {
  return await addObject("icu-charges", data, token);
};

export const updateICUCharge = async (id, data, token = "") => {
  return await updateObject("icu-charges", data, id, token);
};

export const markICUChargePaid = async (id, token = "") => {
  return await addObject(`icu-charges/${id}/mark-paid`, {}, token);
};

// ICU Transfers
export const listICUTransfers = async (params = {}, token = "") => {
  return await getObjectsWithParams("icu-transfers", params, token);
};

export const getICUTransfer = async (id, token = "") => {
  return await getObject("icu-transfers", id, token);
};

export const createICUTransfer = async (data, token = "") => {
  return await addObject("icu-transfers", data, token);
};

// ICU Discharge Plans
export const getICUDischargePlan = async (id, token = "") => {
  return await getObject("icu-discharge-plans", id, token);
};

export const createICUDischargePlan = async (data, token = "") => {
  return await addObject("icu-discharge-plans", data, token);
};

export const updateICUDischargePlan = async (id, data, token = "") => {
  return await updateObject("icu-discharge-plans", data, id, token);
};

